// Single source of truth for turning raw activity action codes into
// human-readable labels. Any unmapped code is auto-prettified so raw
// snake_case (e.g. "auto_reminder_run") can never reach the UI.

const ACTION_LABELS = {
  payment_recorded:        'Payment recorded',
  custom_charge_created:   'Custom charge added',
  discount_given:          'Discount given',
  discount_removed:        'Discount removed',
  late_fee_policy_updated: 'Late fee policy updated',
  payment_confirmed:       'Payment confirmed',
  payment_waived:          'Payment waived',
  proof_approved:          'Payment proof approved',
  proof_rejected:          'Payment proof rejected',
  payment_link_generated:  'Payment link generated',
  reminder_sent:           'Payment reminder sent',
  bulk_reminder_sent:      'Payment reminder sent',
  auto_reminder_run:       'Automatic reminders ran',
  auto_reminder_sent_30:   '30-day payment reminder sent',
  auto_reminder_sent_60:   '60-day payment reminder sent',
  fee_waived:              'Fee written off',
  fee_restored:            'Fee restored',
  create_expense:          'Expense added',
  update_expense:          'Expense updated',
  approve_expense:         'Expense approved',
  reject_expense:          'Expense rejected',
  archive_expense:         'Expense archived',
  cancel_expense:          'Expense cancelled',
  remove_attachment:       'Attachment removed',
  member_approved:         'Member approved',
  member_rejected:         'Member rejected',
  member_application_deleted: 'Application removed',
  student_archived:        'Student archived',
  student_restored:        'Student restored',
  student_deleted:         'Student removed',
  student_added:           'Student added',
  student_access_granted:  'Platform access granted to student',
  trial_converted:         'Trial converted to member',
  trainer_added:           'Trainer added',
  class_created:           'Class created',
  session_created:         'Session created',
  attendance_taken:        'Attendance taken',
  announcement_posted:     'Announcement posted',
  fees_generated:          'Monthly fees generated',
  '2fa_enabled':           'Two-factor authentication enabled',
  '2fa_disabled':          'Two-factor authentication disabled',
  admin_login_2fa:         'Admin signed in with 2FA',
  admin_login_otp_sent:    'Sign-in code sent',
  admin_login_otp_failed:  'Incorrect sign-in code entered',
};

// Actions performed automatically by the system (no human actor).
const SYSTEM_ACTIONS = new Set(['auto_reminder_run', 'auto_reminder_sent_30', 'auto_reminder_sent_60']);

function prettify(code = '') {
  const s = String(code).replace(/_/g, ' ').trim();
  return s ? s.charAt(0).toUpperCase() + s.slice(1) : 'Activity';
}

export function activityLabel(log = {}) {
  if (ACTION_LABELS[log.action]) return ACTION_LABELS[log.action];
  // Use the backend label only if it's actually human-readable
  // (not just the raw action code echoed back).
  if (log.actionLabel && log.actionLabel !== log.action) return log.actionLabel;
  return prettify(log.action);
}

export function isSystemActivity(log = {}) {
  return log.actorType === 'system' || SYSTEM_ACTIONS.has(log.action) || !log.actorName;
}
